import React, { useEffect, useState, useRef } from 'react'
import { useKeyDown } from '../../../../shared/providers/KeyDownProvider'
import { handleForbiddenAction } from '../../lib/helper'
import { ForbiddenActionMessageProps } from './types'

const MESSAGE_TEXT = 'Function Unavailable'
const MESSAGE_TIMEOUT = 500

function ForbiddenActionMessage({ keysToListen }: ForbiddenActionMessageProps) {
  const [showMessage, setShowMessage] = useState(false)
  const messageCleanUpTimerRef = useRef<(() => void) | null>()

  useKeyDown(
    keysToListen,
    () => {
      renderMessage()
    },
    { stopPropagation: true }
  )

  useEffect(() => {
    return () => {
      if (messageCleanUpTimerRef.current) {
        messageCleanUpTimerRef.current = null
      }
    }
  }, [])

  const renderMessage = () => {
    messageCleanUpTimerRef.current = handleForbiddenAction(
      showMessage,
      setShowMessage,
      MESSAGE_TIMEOUT,
      MESSAGE_TEXT
    )
  }

  return (
    <>
      {showMessage ? (
        <div className="message">
          <span>{MESSAGE_TEXT}</span>
        </div>
      ) : null}
    </>
  )
}

export default ForbiddenActionMessage
